import { render, staticRenderFns } from "./registeredDetails.vue?vue&type=template&id=7c8a8d4f&scoped=true"
import script from "./registeredDetails.vue?vue&type=script&lang=js"
export * from "./registeredDetails.vue?vue&type=script&lang=js"
import style0 from "./registeredDetails.vue?vue&type=style&index=0&id=7c8a8d4f&prod&scoped=true&lang=less"
import style1 from "./registeredDetails.vue?vue&type=style&index=1&id=7c8a8d4f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8a8d4f",
  null
  
)

export default component.exports